<div>
  <!-- Top KPI Bar & Action Buttons -->
  <div class="mb-3 px-1 text-dark">
    <!-- Unified Risk Spectrum Strip with Integrated Action Bay -->
    <div class="risk-spectrum-container d-flex align-items-stretch">
      <!-- Left: Spectrum bar & Filter tabs -->
      <div class="spectrum-main d-flex flex-column flex-grow-1">
        <!-- Top 100% Continuous Multi-Segment Spectrum Bar -->
        <div class="spectrum-bar-wrapper">
          <div class="spectrum-bar d-flex">
            <div class="spectrum-segment seg-overdue" [style.width.%]="kpiMetrics.overduePct"
              [class.dimmed]="selectedKpi && selectedKpi !== 'all' && selectedKpi !== 'overdue'"
              [attr.title]="'Overdue: ' + kpiMetrics.overduePct + '%'"></div>
            <div class="spectrum-segment seg-submitted" [style.width.%]="kpiMetrics.submittedPct"
              [class.dimmed]="selectedKpi && selectedKpi !== 'all' && selectedKpi !== 'submitted'"
              [attr.title]="'Submitted: ' + kpiMetrics.submittedPct + '%'"></div>
            <div class="spectrum-segment seg-under-review" [style.width.%]="kpiMetrics.underReviewPct"
              [class.dimmed]="selectedKpi && selectedKpi !== 'all' && selectedKpi !== 'under_review'"
              [attr.title]="'Under Review: ' + kpiMetrics.underReviewPct + '%'"></div>
            <div class="spectrum-segment seg-wip" [style.width.%]="kpiMetrics.wipPct"
              [class.dimmed]="selectedKpi && selectedKpi !== 'all' && selectedKpi !== 'wip'"
              [attr.title]="'WIP: ' + kpiMetrics.wipPct + '%'"></div>
            <div class="spectrum-segment seg-closed" [style.width.%]="kpiMetrics.closedPct"
              [class.dimmed]="selectedKpi && selectedKpi !== 'all' && selectedKpi !== 'closed'"
              [attr.title]="'Completed: ' + kpiMetrics.closedPct + '%'"></div>
            <div class="spectrum-segment seg-closed-cro" [style.width.%]="kpiMetrics.closedCroPct"
              [class.dimmed]="selectedKpi && selectedKpi !== 'all' && selectedKpi !== 'closed_cro'"
              [attr.title]="'Closed: ' + kpiMetrics.closedCroPct + '%'"></div>
          </div>
        </div>

        <!-- Connected Filter Segments -->
        <div class="spectrum-tabs d-flex">
          <!-- All Risks (Default Active) -->
          <button type="button" class="spectrum-tab tab-all flex-fill text-start" [class.active]="isKpiSelected('all')"
            (click)="toggleKpiFilter('all')" title="Click to show all risks">
            <div class="tab-header d-flex align-items-center justify-content-between">
              <span class="tab-title">All Risks</span>
            </div>
            <div class="tab-body d-flex align-items-baseline justify-content-between mt-1">
              <span class="tab-count">{{ kpiMetrics.total }}</span>
            </div>
          </button>

          <!-- Overdue -->
          <button type="button" class="spectrum-tab tab-overdue flex-fill text-start"
            [class.active]="isKpiSelected('overdue')" (click)="toggleKpiFilter('overdue')"
            title="Click to filter by Overdue">
            <div class="tab-header d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span class="tab-dot dot-overdue"></span>
                <span class="tab-title">Overdue</span>
              </div>
              <span class="tab-pct-badge badge-overdue">{{ kpiMetrics.overduePct }}%</span>
            </div>
            <div class="tab-body d-flex align-items-baseline justify-content-between mt-1">
              <span class="tab-count text-overdue">{{ kpiMetrics.overdueCount }}</span>
            </div>
          </button>

          <!-- Submitted -->
          <button type="button" class="spectrum-tab tab-submitted flex-fill text-start"
            [class.active]="isKpiSelected('submitted')" (click)="toggleKpiFilter('submitted')"
            title="Click to filter by Submitted">
            <div class="tab-header d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span class="tab-dot dot-submitted"></span>
                <span class="tab-title">Mapped</span>
              </div>
              <span class="tab-pct-badge badge-submitted">{{ kpiMetrics.submittedPct }}%</span>
            </div>
            <div class="tab-body d-flex align-items-baseline justify-content-between mt-1">
              <span class="tab-count text-submitted">{{ kpiMetrics.submittedCount }}</span>
            </div>
          </button>

          <!-- Under Review -->
          <button type="button" class="spectrum-tab tab-under-review flex-fill text-start"
            [class.active]="isKpiSelected('under_review')" (click)="toggleKpiFilter('under_review')"
            title="Click to filter by Under Review">
            <div class="tab-header d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span class="tab-dot dot-under-review"></span>
                <span class="tab-title">Under Review</span>
              </div>
              <span class="tab-pct-badge badge-under-review">{{ kpiMetrics.underReviewPct }}%</span>
            </div>
            <div class="tab-body d-flex align-items-baseline justify-content-between mt-1">
              <span class="tab-count text-under-review">{{ kpiMetrics.underReviewCount }}</span>
            </div>
          </button>

          <!-- WIP -->
          <button type="button" class="spectrum-tab tab-wip flex-fill text-start" [class.active]="isKpiSelected('wip')"
            (click)="toggleKpiFilter('wip')" title="Click to filter by WIP">
            <div class="tab-header d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span class="tab-dot dot-wip"></span>
                <span class="tab-title">WIP</span>
              </div>
              <span class="tab-pct-badge badge-wip">{{ kpiMetrics.wipPct }}%</span>
            </div>
            <div class="tab-body d-flex align-items-baseline justify-content-between mt-1">
              <span class="tab-count text-wip">{{ kpiMetrics.wipCount }}</span>
            </div>
          </button>

          <!-- Closed -->
          <button type="button" class="spectrum-tab tab-closed flex-fill text-start"
            [class.active]="isKpiSelected('closed')" (click)="toggleKpiFilter('closed')"
            title="Click to filter by Closed">
            <div class="tab-header d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span class="tab-dot dot-closed"></span>
                <span class="tab-title">Completed</span>
              </div>
              <span class="tab-pct-badge badge-closed">{{ kpiMetrics.closedPct }}%</span>
            </div>
            <div class="tab-body d-flex align-items-baseline justify-content-between mt-1">
              <span class="tab-count text-closed">{{ kpiMetrics.closedCount }}</span>
            </div>
          </button>

          <!-- Closed -->
          <button type="button" class="spectrum-tab tab-closed-cro flex-fill text-start"
            [class.active]="isKpiSelected('closed_cro')" (click)="toggleKpiFilter('closed_cro')"
            title="Click to filter by Closed">
            <div class="tab-header d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <mat-icon class="tab-status-icon icon-closed-cro">check_circle</mat-icon>
                <span class="tab-title">Closed</span>
              </div>
              <span class="tab-pct-badge badge-closed-cro">{{ kpiMetrics.closedCroPct }}%</span>
            </div>
            <div class="tab-body d-flex align-items-baseline justify-content-between mt-1">
              <span class="tab-count text-closed-cro">{{ kpiMetrics.closedCroCount }}</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Vertical Divider -->
      <div class="spectrum-action-divider"></div>

      <!-- Right: Airo Cue Action Bay -->
      <div class="spectrum-action-bay d-flex flex-column align-items-center justify-content-center">
        <app-llm-inference inferenceType="risk" viewMode="popup" viewContext="popup"
          [outputRef]="selectedCycleId ? { project_id: projectId, cycle: selectedCycleId } : { project_id: projectId }"
          [cycleId]="selectedCycleId">
        </app-llm-inference>
      </div>
    </div>
  </div>

  <!-- Deep Dive Table for Project-Level Risks -->
  <div class="custom-table" style="position: relative;">
    <app-loading *ngIf="tableLoading"></app-loading>
    <div class="table-container table-responsive" style="max-height: calc(100vh - 280px)">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="vertical-align: middle; width: 14%;" scope="col">Domain</th>
            <th style="vertical-align: middle; width: 14%;" scope="col">Sub Domain</th>
            <th style="vertical-align: middle; text-align: center; width: 20%;" scope="col">Risk</th>
            <th style="vertical-align: middle; text-align: center; width: 6%;" scope="col">Airo Cue Summary</th>
            <th style="vertical-align: middle; width: 18%;" scope="col">Mitigations</th>
            <th style="vertical-align: middle; width: 16%;" scope="col">Controls</th>
            <th style="vertical-align: middle; text-align: center; width: 6%;" scope="col">Inherent Risk Score</th>
            <th style="vertical-align: middle; text-align: center; width: 6%;" scope="col">Residual Risk Score</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="groupedDomains?.length; else noData">
            <ng-container *ngFor="let domain of groupedDomains">
              <ng-container *ngFor="let subDomain of domain.subDomains">
                <ng-container *ngFor="let risk of subDomain.risks">
                  <ng-container *ngFor="let record of risk.records; let j = index">
                    <tr>
                      <!-- Domain -->
                      <td *ngIf="
                        j === 0 &&
                        risk === subDomain.risks[0] &&
                        subDomain === domain.subDomains[0]
                      " class="highlighted" [attr.rowspan]="domain.totalRows" [matTooltip]="domain.domainName">
                        <div class="wrap-two-lines">{{ domain.domainName }}</div>
                      </td>

                      <!-- Subdomain -->
                      <td *ngIf="
                        j === 0 &&
                        risk === subDomain.risks[0]
                      " class="highlighted" [attr.rowspan]="subDomain.totalRows"
                        [matTooltip]="subDomain.subDomainName">
                        <div class="wrap-two-lines">{{ subDomain.subDomainName }}</div>
                      </td>

                      <!-- Risk (Click to open Risklog Dialog) -->
                      <td *ngIf="j === 0" class="highlighted cursor-pointer" [attr.rowspan]="risk.totalRows"
                        [matTooltip]="risk.riskName" (click)="onTableRiskClick(domain, subDomain, risk, record, 0)">
                        <div class="d-flex align-items-center">
                          <span class="indicator-container">
                            <mat-icon *ngIf="isClosedByCro(risk, record)"
                              class="closed-cro-icon">check_circle</mat-icon>
                            <span *ngIf="!isClosedByCro(risk, record)" class="risk-legend-indicator"
                              [style.background]="getBackgroundColor(getRiskColor(risk, record))">
                            </span>
                          </span>
                          <span class="wrap-two-lines risk-name-link">{{ risk.riskName }}</span>
                        </div>
                      </td>

                      <!-- Airo Cue Summary -->
                      <td *ngIf="j === 0" [attr.rowspan]="risk.totalRows"
                        style="text-align: center; vertical-align: middle;">
                        <span *ngIf="hasAiSummary(risk, record)" matTooltip="Click to view Airo Cue Summary"
                          class="airo-cue-badge d-inline-flex align-items-center justify-content-center"
                          style="width: 22px; height: 22px; background-color: #232459; border-radius: 50%;"
                          (click)="onTableRiskClick(domain, subDomain, risk, record, 1)">
                          <img src="assets/Icons/airoIcon.png" style="height: 12px; width: 12px;" alt="Airo Cue" />
                        </span>
                        <span *ngIf="!hasAiSummary(risk, record)">-</span>
                      </td>


                      <!-- Mitigations -->
                      <td>
                        <ul class="ps-3 mb-0 text-start" style="margin: 0; padding-left: 1.2rem;"
                          *ngIf="record.details?.length || record.action_plans; else noMitigations">
                          <ng-container *ngFor="let detail of record.details">
                            <li *ngIf="detail?.action_plan" class="mb-1">
                              <div class="d-flex align-items-start justify-content-between gap-1">
                                <span class="wrap-two-lines flex-grow-1" style="min-width: 0;"
                                  [matTooltip]="detail.action_plan">{{ detail.action_plan }}</span>
                                <span *ngIf="detail?.status" class="mitigation-status-pill flex-shrink-0"
                                  [ngClass]="detail.status.toLowerCase() === 'closed' ? 'status-closed' : 'status-open'">
                                  {{ detail.status }}
                                </span>
                              </div>
                            </li>
                          </ng-container>
                          <li *ngIf="record.action_plans && !record.details?.length">
                            <div class="wrap-two-lines" [matTooltip]="record.action_plans">{{ record.action_plans }}
                            </div>
                          </li>
                        </ul>
                        <ng-template #noMitigations>-</ng-template>
                      </td>

                      <!-- Controls -->
                      <td>
                        <ul class="ps-3 mb-0 text-start" style="margin: 0; padding-left: 1.2rem;"
                          *ngIf="(record.details?.controls || record.controls)?.length; else noControls">
                          <li *ngFor="let control of (record.details?.controls || record.controls)">
                            <div class="wrap-two-lines"
                              [matTooltip]="control.description || control.control_name || control">
                              {{ control.description || control.control_name || control }}
                            </div>
                          </li>
                        </ul>
                        <ng-template #noControls>-</ng-template>
                      </td>

                      <!-- Inherent Risk Score -->
                      <td [matTooltip]="getScoreTooltip(getInherentScore(record))" style="text-align: center;">
                        <div class="score-circle" [style.background]="getRiskScoreColor(getInherentScore(record))">
                          {{ getInherentScore(record) }}
                        </div>
                      </td>

                      <!-- Residual Risk Score -->
                      <td [matTooltip]="getScoreTooltip(getResidualScore(record))" style="text-align: center;">
                        <div class="score-circle" [style.background]="getRiskScoreColor(getResidualScore(record))">
                          {{ getResidualScore(record) }}
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-template #noData>
            <tr>
              <td colspan="8" class="text-center text-muted" style="padding: 40px 0">
                {{ commonText.no_records_found }}
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="d-flex align-items-center font-13 mt-2" *ngIf="filteredRecords?.length > 0">
      <div class="p-1">
        <div class="d-flex flex-row align-items-center text-dark">
          <span class="p-1">Displaying </span>
          <span class="p-1" style="margin-bottom: 0 !important">
            {{ startValue + 1 }}-{{
            endValue > filteredRecords.length
            ? filteredRecords.length
            : endValue
            }}
          </span>
          <span class="p-1">of {{ filteredRecords.length | appFormat : "number" }}</span>
          <span class="p-1">records</span>
        </div>
      </div>
      <div class="p-1">
        <select class="form-select form-select-sm table-sort-filter" aria-label="Default select example"
          [(ngModel)]="sortRecords" (ngModelChange)="onPageSizeChange()">
          <option *ngFor="let option of sortOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
      <div class="p-1 ms-auto">
        <ngb-pagination [pageSize]="sortRecords" [collectionSize]="filteredRecords?.length" [maxSize]="2"
          [rotate]="true" [(page)]="CurrentPage" [boundaryLinks]="true" (pageChange)="getRecords()">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>

<!-- ========================================================================= -->
<!-- ORIGINAL RISKLOG HEATMAP CODE (COMMENTED OUT AS PER REQUIREMENT)          -->
<!-- ========================================================================= -->
<!--
<ng-container *ngIf="hasAnyVisibleRisks(); else noRisks">
  <div class="table" style="margin-bottom: 0px">
    <div class="table-row" style="position: sticky; top: 0px; z-index: 3; background: white">
      <div class="table-cell cursor-pointer domain fw-bold" style="
        max-width: 180px;
        min-width: 180px;
        width: 180px;
        text-align: left;
        font-size: 14px;
        background: white;
        position: sticky;
        top: 0;
        left: 0;
        z-index: 3;
      ">
        <div style="background-color: #0bb797; border-radius: 10px; padding: 8px; color: white;">Domain</div>
      </div>
      <div class="table-cell table-nest">
        <div class="table-row" style="width: 100%; position: sticky; top: 0; left: 180px; z-index: 3">
          <div class="table-cell cursor-pointer subdomain" style="
            max-width: 150px;
            min-width: 150px;
            width: 150px;
            text-align: left;
            font-size: 14px;
            background-color: white;
            position: sticky;
            top: 0;
            left: 180px;
            z-index: 3;
          ">
            <div style="background-color: #0bb797; border-radius: 10px; padding: 8px; color: white;">
              Sub Domain
            </div>
          </div>
          <div class="table-cell cursor-pointer" style="
            max-width: 180px;
            min-width: 180px;
            width: 180px;
            padding: 5px;
            text-align: left;
            font-size: 14px;
            background-color: white;
            position: sticky;
            top: 0;
            left: 0;
            z-index: 2;
          ">
            <div style="
              width: 90%;
              margin: 0 auto;
              background-color: #0bb797;
              border-radius: 10px;
              padding: 8px;
              color: white;
            ">
              Risk
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="riskCenterList" style="overflow: scroll; height: calc(100vh - 425px)">
    <div class="container-fluid p-0">
      <div class="table">
        <div class="table-row" *ngFor="
          let domain of getFilteredArray(riskArrayHeatMap);
          let subindex = index
        ">
          <div class="table-cell cursor-pointer fw-bold" style="
            max-width: 180px;
            min-width: 180px;
            width: 180px;
            font-size: 14px;
            position: sticky;
            left: 0;
            z-index: 1;
            height: 100px;
          ">
            <div class="domain text-overflow-wrap" [ngStyle]="{
              background: getBackgroundColor(domain?.color)
            }" style="border-radius: 10px; height: 100%">
              {{ domain?.display_name }}
            </div>
          </div>
          <div class="table-cell table-nest" *ngIf="domain.children">
            <div class="table-row" style="position: relative" *ngFor="
              let subdomain of getFilteredArray(domain?.children);
              let subsubindex = index
            ">
              <div class="table-cell cursor-pointer" id="subdomain_{{ subsubindex }}" style="
                max-width: 150px;
                min-width: 150px;
                width: 150px;
                font-size: 13px;
                position: sticky;
                left: 180px;
                z-index: 2;
                height: 100px;
              ">
                <div class="subdomain text-overflow-wrap" [ngStyle]="{
                  background: getBackgroundColor(subdomain?.color)
                }" style="border-radius: 10px; padding: 8px; height: 100%"
                  [matTooltip]="subdomain?.display_name | titlecase">
                  {{ subdomain?.display_name }}
                </div>
              </div>
              <div class="table-cell" style="
                max-width: 180px;
                min-width: 180px;
                position: relative;
                cursor: pointer;
              " (click)="onClickRisk(domain, subdomain, risk, riskLogPop)" *ngFor="
                let risk of getFilteredArray(subdomain?.children);
                let risksubindex = index
              ">
                <div id="risksubdomain_{{ subsubindex }}_{{ risksubindex }}" style="
                  position: absolute;
                  font-size: 13px;
                  text-align: center;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  width: 90%;
                  height: 100%;
                  padding: 5px 0;
                ">
                  <div [ngStyle]="{ background: getBackgroundColor(risk?.color) }" style="
                    border-radius: 10px;
                    padding: 5px 6px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    overflow: hidden;
                    box-sizing: border-box;
                  ">
                    <!~~ Top row: 4 metrics/indicators ~~>
                    <div
                      style="display: flex; align-items: center; justify-content: space-between; width: 100%; flex-shrink: 0;">
                      <!~~ Placeholder 2 / Risk Type ~~>
                      <span *ngIf="risk?.risk_type?.display_name; else emptyType" class="info-tile"
                        matTooltip="Risk Type: {{risk.risk_type?.display_name}}">{{
                        risk.risk_type?.display_name}}</span>
                      <ng-template #emptyType><span style="width: 14px;"></span></ng-template>

                      <!~~ Impact badge ~~>
                      <span *ngIf="risk?.risk_impact?.display_name; else emptyBadge" class="info-tile"
                        matTooltip="Risk Impact: {{risk.risk_impact?.display_name}}">{{
                        risk.risk_impact?.display_name}}</span>
                      <ng-template #emptyBadge><span style="width: 18px;"></span></ng-template>

                      <!~~ Residual Score / Inherent for Accept ~~>
                      <span class="info-tile" [matTooltip]="'Residual Risk Score: ' +  risk?.residual_risk_score">{{
                        risk?.residual_risk_score ?? '-' }}</span>
                    </div>

                    <!~~ Risk name: 2-line clamp ~~>
                    <div class="text-overflow-wrap"
                      [matTooltip]="risk?.risk_id ? risk.risk_id + ' - ' + risk.display_name : risk.display_name" style="
                    font-size: 12px;
                    color: white;
                    text-align: center;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    line-height: 1.3;
                    word-break: break-word;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  ">
                      {{
                      getTrucatedName(
                      subdomain?.display_name,
                      (risk?.risk_id ? risk.risk_id + ' - ' + risk.display_name : risk.display_name),
                      risk?.short_description
                      )
                      }}
                    </div>

                    <!~~ Bottom: status & icons container ~~>
                    <div *ngIf="risk?.status || risk?.has_ai_summary" style="
                    text-align: center;
                    flex-shrink: 0;
                    white-space: nowrap;
                    position: relative;
                  ">
                      <!~~ Airo Icon (Bottom Left) ~~>
                      <span *ngIf="risk?.has_ai_summary" matTooltip="Airo Cue Summary Available  " style="
                          position: absolute;
                          left: -2px;
                          bottom: 0px;
                          width: 16px;
                          height: 16px;
                          background-color: #232459;
                          border-radius: 50%;
                          display: inline-flex;
                          align-items: center;
                          justify-content: center;
                        ">
                        <img src="/assets/Icons/airoIcon.png" style="height: 10px; width: 10px;" alt="Airo" />
                      </span>

                      <!~~ Closed Checkmark (Bottom Right) ~~>
                      <mat-icon *ngIf="isClosedByCro(risk)"
                        style="
                          position: absolute;
                          right: -2px;
                          bottom: 0px;
                          font-size: 16px;
                          width: 16px;
                          height: 16px;
                          line-height: 16px;
                          background: white;
                          color: #0bb797;
                          border-radius: 50%;
                        ">check_circle</mat-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #noRisks>
  <div class="riskCenterList d-flex justify-content-center align-items-center" style="height: calc(100vh - 425px);">
    {{ commonText.no_records_found }}
  </div>
</ng-template>
-->